import React, { useState } from "react";
import "./ModelManagement.css";
const ModelManagement = () => {
  const [uploadedModel, setUploadedModel] = useState(null);
  const [currentModelVersion, setCurrentModelVersion] = useState("v1.0");
  const [performanceMetrics, setPerformanceMetrics] = useState({
    precision: 0.95,
    recall: 0.92,
    f1Score: 0.93,
    mAP: 0.9,
    inferenceTime: "20ms",
  });

  const handleModelUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      setUploadedModel(file);
      console.log("Uploaded Model:", file.name);
    }
  };

  const deployModel = () => {
    console.log("Deploying model:", uploadedModel);
    setCurrentModelVersion("v1.1");
  };

  const rollbackModel = () => {
    console.log("Rolling back to previous model");
    setCurrentModelVersion("v1.0");
  };

  return (
    <div className="model-mngmnt-container">
      <h1 className="model-mngmnt-header">Model Management</h1>

      <section className="model-mngmnt-section">
        <h2 className="model-mngmnt-section-header">Model Replacement</h2>
        <input
          type="file"
          onChange={handleModelUpload}
          accept=".pt"
          className="model-mngmnt-input-file"
        />
        {uploadedModel && (
          <div className="model-mngmnt-model-info">
            <p className="model-mngmnt-info-text">
              Uploaded Model: {uploadedModel.name}
            </p>
            <button
              className="model-mngmnt-btn model-mngmnt-btn-primary"
              onClick={deployModel}
            >
              Deploy Model
            </button>
          </div>
        )}
      </section>

      <section className="model-mngmnt-section">
        <h2 className="model-mngmnt-section-header">Model Evaluation</h2>
        <div className="model-mngmnt-metrics">
          <p>
            <strong>Current Model Version:</strong> {currentModelVersion}
          </p>
          <p>
            <strong>Precision:</strong> {performanceMetrics.precision}
          </p>
          <p>
            <strong>Recall:</strong> {performanceMetrics.recall}
          </p>
          <p>
            <strong>F1 Score:</strong> {performanceMetrics.f1Score}
          </p>
          <p>
            <strong>mAP:</strong> {performanceMetrics.mAP}
          </p>
          <p>
            <strong>Inference Time:</strong> {performanceMetrics.inferenceTime}
          </p>
        </div>
      </section>

      <section className="model-mngmnt-section">
        <h2 className="model-mngmnt-section-header">Model Integration</h2>
        <button
          className="model-mngmnt-btn model-mngmnt-btn-success"
          onClick={deployModel}
        >
          Deploy Current Model
        </button>
        <button
          className="model-mngmnt-btn model-mngmnt-btn-danger"
          onClick={rollbackModel}
          style={{ marginLeft: "20px" }}
        >
          Rollback to Previous Model
        </button>
      </section>
    </div>
  );
};

export default ModelManagement;
